import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=35b8fd2e&scoped=true"
import script from "./ProjectTree.vue?vue&type=script&lang=js"
export * from "./ProjectTree.vue?vue&type=script&lang=js"
import style0 from "./ProjectTree.vue?vue&type=style&index=0&id=35b8fd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8fd2e",
  null
  
)

export default component.exports